import { PINNED_Z_INDEX } from "lib/@components/managed-columns/pinned-cell-styles"

const AI_SUGGESTION_TOOLTIP =
    "Our AI suggests grouping asset types into Parents and Children so that suggested schedule mapping is improved in the next step."

const headerCell = {
    zIndex: PINNED_Z_INDEX.header - 1,
}

const pinnedHeaderCell = {
    ...headerCell,
    position: "sticky",
    zIndex: PINNED_Z_INDEX.header,
}

export const typeReviewColumns = [
    {
        field: "originalAssetType",
        label: "Imported Asset Type",
        width: 180,
        sx: {
            ...pinnedHeaderCell,
            left: 0,
            borderRight: "1px solid",
            borderRightColor: "divider",
        },
    },
    {
        field: "suggestedTypeName",
        label: "AI Suggested Asset Type",
        width: 200,
        info: AI_SUGGESTION_TOOLTIP,
        sx: headerCell,
    },
    {
        field: "suggestedParent",
        label: "AI Suggested Parent",
        width: 180,
        info: AI_SUGGESTION_TOOLTIP,
        sx: headerCell,
    },
    {
        field: "count",
        label: "Count",
        align: "center",
        width: 90,
        sx: headerCell,
    },
    {
        field: "identifiedAsset",
        label: "Asset Tag",
        width: 160,
        sx: headerCell,
    },
    {
        field: "reviewStatus",
        label: "Map Asset Type",
        align: "center",
        width: 190,
        sx: {
            ...pinnedHeaderCell,
            right: 0,
            borderLeft: "1px solid",
            borderLeftColor: "divider",
        },
    },
]
